var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSapphire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_77669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.10156 0.775391H17.9016V17.5754H1.10156V0.775391Z",
    fill: "#4382FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9016 17.5732L9.50156 15.291L1.10156 17.5732",
    fill: "#4382FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9016 0.775391H1.10156L9.50156 3.05755L17.9016 0.775391ZM15.6194 9.17539L17.9016 17.5754V0.775391L15.6194 9.17539Z",
    fill: "#BBE5EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50156 3.05755L1.10156 0.775391L3.38372 9.17539L9.50156 3.05755ZM3.38372 9.17539L1.10156 17.5754L9.50156 15.2932L3.38372 9.17539Z",
    fill: "#2F1FC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5178 1.17383L9.11784 3.45599L3 9.57383L9.11784 15.6917L17.5178 17.9738L15.2357 9.57383L17.5178 1.17383Z",
    fill: "#2F1FC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3.05664L13.7069 11.0992L15.6178 9.17448L9.5 3.05664Z",
    fill: "#2F1FC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.37086 7.41819L2.37085 7.41819C2.18882 7.43471 2.12928 7.64677 2.25513 7.75499C2.25513 7.75499 2.25513 7.755 2.25513 7.755L5.92095 10.9069L6.00685 10.9807L5.98143 11.0911L4.9086 15.7499C4.9086 15.7499 4.90859 15.7499 4.90859 15.7499C4.87274 15.9058 5.04902 16.0509 5.21026 15.9572L9.40578 13.5189L9.5 13.4642L9.59421 13.5189L13.7897 15.9572C13.951 16.0509 14.1273 15.9057 14.0914 15.7499L14.2741 15.7079L14.0914 15.7499L13.0186 11.0911L12.9932 10.9807L13.0791 10.9069L16.7449 7.755C16.8707 7.64677 16.8112 7.43471 16.6291 7.41819L16.6291 7.41819L11.7706 6.97712L11.6605 6.96712L11.6159 6.8659L9.68595 2.47969L9.68594 2.47967C9.61654 2.3219 9.38349 2.32185 9.31404 2.47969L7.38408 6.86594L7.33954 6.96716L7.22941 6.97716L2.37086 7.41819Z",
    fill: "#94EBFA",
    stroke: "#4382FF",
    strokeWidth: 0.375
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_77669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.173828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSapphire);
export default __webpack_public_path__ + "static/media/star_sapphire.82652f5c8a855e32d81ddfe9d8d1ddf8.svg";
export { ForwardRef as ReactComponent };